import React from "react";
import { Empty, Table } from "antd";
import type { TableProps } from "antd";
import type { TablePaginationConfig } from "antd/es/table";
import "./appTable.scss";

export const TABLE_PAGE_SIZE = 10;
export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const defaultRowKey = (record: any) => record?._id ?? record?.id ?? record?.key;

function AppTable<T extends object = any>({
  className,
  pagination,
  rowKey = defaultRowKey,
  scroll: _scroll,
  locale,
  ...rest
}: TableProps<T>) {
  const mergedPagination: false | TablePaginationConfig =
    pagination === false
      ? false
      : {
          defaultPageSize: TABLE_PAGE_SIZE,
          pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
          showSizeChanger: true,
          showTotal: (total, [from, to]) => `${from}-${to} of ${total}`,
          hideOnSinglePage: false,
          ...(pagination || {}),
        };

  return (
    <Table<T>
      {...rest}
      rowKey={rowKey}
      size="middle"
      className={["app-table", className].filter(Boolean).join(" ")}
      pagination={mergedPagination}
      scroll={{ x: "max-content" }}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No records found" />,
        ...locale,
      }}
    />
  );
}

export default AppTable;
